// Wait for the DOM to be fully loaded before initializing the slider
document.addEventListener('DOMContentLoaded', function() {
    // Select the element with class 'collection-header-link-blocks'
    var elem = document.querySelector('.collection-header-link-blocks');
    
    // Initialize Flickity slider with custom options
    var flkty = new Flickity( elem, {
      // Align cells to the left
      cellAlign: 'left',
      // Contain cells within the container
      contain: true,
      // Allow free scrolling
      freeScroll: true,
      // Enable infinite scrolling
      wrapAround: true,
      // Show previous and next buttons (although we hide these with CSS on mobile)
      prevNextButtons: true,
      // Hide pagination dots
      pageDots: false
    });
});
